import { apiBaseUrl } from "./auth";
import { getStoredLanguage } from "../context/I18nContext";

const MESSAGES_BASE = `${apiBaseUrl}/api/lessons/messages`;

async function request(path, { accessToken, method = "GET", body, params } = {}) {
  const headers = {
    Accept: "application/json",
    "Accept-Language": getStoredLanguage(),
  };
  if (accessToken) headers.Authorization = `Bearer ${accessToken}`;

  // FormData (file upload) sets its own multipart Content-Type.
  const isForm = typeof FormData !== "undefined" && body instanceof FormData;
  if (body && !isForm) headers["Content-Type"] = "application/json";

  const query = params ? `?${new URLSearchParams(params).toString()}` : "";
  const response = await fetch(`${MESSAGES_BASE}${path}${query}`, {
    method,
    headers,
    body: body ? (isForm ? body : JSON.stringify(body)) : undefined,
  });

  const isJson = response.headers.get("content-type")?.includes("application/json");
  const payload = isJson ? await response.json() : {};
  if (!response.ok) {
    const error = new Error(payload.error || "Une erreur est survenue");
    error.status = response.status;
    throw error;
  }
  return payload;
}

export function fetchContacts({ accessToken }) {
  return request("/contacts/", { accessToken });
}

export function fetchConversations({ accessToken }) {
  return request("/conversations/", { accessToken });
}

export function startConversation({ accessToken, userId, studentId }) {
  return request("/conversations/", {
    accessToken,
    method: "POST",
    body: { user_id: userId, student_id: studentId },
  });
}

export function fetchMessages({ accessToken, conversationId, after }) {
  return request(`/conversations/${conversationId}/messages/`, {
    accessToken,
    params: after ? { after } : undefined,
  });
}

export function sendMessage({ accessToken, conversationId, body, files = [], replyTo }) {
  let payload = { body, reply_to: replyTo || undefined };
  if (files.length) {
    payload = new FormData();
    payload.append("body", body || "");
    files.forEach((file) => payload.append("files", file));
    if (replyTo) payload.append("reply_to", String(replyTo));
  }
  return request(`/conversations/${conversationId}/messages/`, {
    accessToken,
    method: "POST",
    body: payload,
  });
}

export function editMessage({ accessToken, messageId, body }) {
  return request(`/items/${messageId}/`, { accessToken, method: "PATCH", body: { body } });
}

export function deleteMessage({ accessToken, messageId }) {
  return request(`/items/${messageId}/`, { accessToken, method: "DELETE" });
}

export function reactToMessage({ accessToken, messageId, emoji }) {
  return request(`/items/${messageId}/react/`, { accessToken, method: "POST", body: { emoji } });
}

export function fetchUnreadCount({ accessToken }) {
  return request("/unread/", { accessToken });
}

// Lets the sidebar badge refresh as soon as a conversation is read.
export const MESSAGES_READ_EVENT = "casaclass:messages-read";
